/* =========================================================
   KNOTS — flag bearer in the header
   Needs the classic Three.js build loaded first (global THREE)
   and <canvas id="flag"> in the header.
   ========================================================= */
(() => {
  const canvas = document.getElementById('flag');
  if (!canvas || !window.THREE) return;

  const SHAPES = [{"outer":[[0.42,1.33],[0.39,1.305],[0.395,1.28],[0.275,1.325],[0.21,1.325],[0.02,1.255],[-0.1,1.275],[-0.15,1.21],[-0.185,1.125],[-0.185,1.05],[-0.23,1.01],[-0.255,0.955],[-0.255,0.89],[-0.19,0.935],[-0.09,0.945],[-0.04,0.97],[-0.055,0.905],[-0.035,0.9],[-0.035,0.85],[-0.045,0.83],[-0.105,0.835],[-0.125,0.8],[-0.17,0.78],[-0.17,0.72],[-0.3,0.56],[-0.405,0.365],[-0.405,0.34],[-0.375,0.315],[-0.39,0.275],[-0.34,0.235],[-0.38,0.185],[-0.4,0.12],[-0.435,0.08],[-0.4,0.055],[-0.385,0.065],[-0.345,0.005],[-0.275,0.005],[-0.285,0.035],[-0.335,0.075],[-0.345,0.105],[-0.255,0.205],[-0.16,0.17],[-0.14,0.325],[-0.065,0.415],[-0.005,0.35],[0.07,0.295],[0.055,0.26],[0.035,0.25],[0.0,0.155],[-0.005,0.01],[0.04,0.005],[0.045,0.02],[0.06,0.005],[0.165,0.005],[0.15,0.04],[0.115,0.05],[0.075,0.085],[0.075,0.105],[0.125,0.23],[0.115,0.24],[0.155,0.305],[0.135,0.365],[0.185,0.53],[0.22,0.56],[0.21,0.61],[0.28,0.845],[0.325,0.885],[0.31,0.945],[0.41,1.275],[0.43,1.295]],"holes":[[[0.035,0.555],[0.04,0.55],[0.05,0.55],[0.055,0.545],[0.065,0.545],[0.07,0.54],[0.1,0.54],[0.105,0.545],[0.11,0.545],[0.115,0.55],[0.15,0.55],[0.155,0.545],[0.16,0.545],[0.17,0.535],[0.165,0.53],[0.165,0.52],[0.16,0.515],[0.16,0.505],[0.155,0.5],[0.155,0.485],[0.15,0.48],[0.15,0.47],[0.145,0.465],[0.145,0.455],[0.14,0.45],[0.14,0.44],[0.135,0.435],[0.135,0.42],[0.13,0.415],[0.13,0.405],[0.125,0.4],[0.125,0.395],[0.12,0.39],[0.115,0.39],[0.11,0.395],[0.11,0.4],[0.1,0.41],[0.1,0.415],[0.085,0.43],[0.085,0.435],[0.06,0.46],[0.06,0.465],[0.035,0.49],[0.035,0.495],[0.03,0.5],[0.03,0.55]],[[0.255,0.825],[0.255,0.81],[0.25,0.805],[0.25,0.795],[0.245,0.79],[0.245,0.78],[0.24,0.775],[0.24,0.76],[0.235,0.755],[0.235,0.745],[0.23,0.74],[0.23,0.73],[0.225,0.725],[0.225,0.715],[0.22,0.71],[0.22,0.695],[0.215,0.69],[0.215,0.68],[0.21,0.675],[0.21,0.665],[0.205,0.66],[0.205,0.645],[0.2,0.64],[0.2,0.63],[0.195,0.625],[0.195,0.615],[0.19,0.61],[0.18,0.61],[0.175,0.605],[0.17,0.605],[0.16,0.595],[0.13,0.595],[0.105,0.62],[0.095,0.62],[0.08,0.63],[0.07,0.63],[0.065,0.635],[0.055,0.635],[0.05,0.64],[0.05,0.645],[0.055,0.65],[0.055,0.66],[0.06,0.665],[0.06,0.7],[0.065,0.705],[0.07,0.705],[0.075,0.71],[0.105,0.71],[0.11,0.715],[0.125,0.715],[0.13,0.72],[0.145,0.725],[0.16,0.74],[0.165,0.74],[0.19,0.765],[0.195,0.765],[0.22,0.79],[0.22,0.795],[0.25,0.83]],[[0.32,1.02],[0.315,1.015],[0.315,1.005],[0.31,1.0],[0.31,0.99],[0.305,0.985],[0.295,0.945],[0.255,0.925],[0.24,0.885],[0.225,0.87],[0.165,0.84],[0.125,0.8],[0.075,0.8],[0.07,0.795],[0.055,0.795],[0.05,0.79],[0.04,0.79],[0.035,0.795],[0.035,0.815],[0.05,0.825],[0.065,0.825],[0.065,0.86],[0.07,0.865],[0.08,0.865],[0.07,0.905],[0.075,0.91],[0.085,0.91],[0.085,0.92],[0.08,0.925],[0.08,0.935],[0.075,0.94],[0.07,0.96],[0.05,0.98],[0.04,0.985],[0.02,0.985],[0.015,0.99],[0.02,0.995],[0.03,0.995],[0.035,1.0],[0.06,1.0],[0.065,1.005],[0.12,1.005],[0.125,1.0],[0.235,1.0],[0.24,1.005],[0.255,1.005],[0.26,1.01],[0.27,1.01],[0.275,1.015],[0.285,1.015],[0.305,1.025],[0.315,1.025]]]}];
  const COLOR = 0x4346B8;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toShape(def){
    const s = new THREE.Shape();
    def.outer.forEach(([x, y], i) => i ? s.lineTo(x, y) : s.moveTo(x, y));
    for (const h of def.holes){
      const p = new THREE.Path();
      h.forEach(([x, y], i) => i ? p.lineTo(x, y) : p.moveTo(x, y));
      s.holes.push(p);
    }
    return s;
  }

  const geo = new THREE.ExtrudeGeometry(SHAPES.map(toShape), {
    depth: 0.19, bevelEnabled: true, bevelThickness: 0.016, bevelSize: 0.016, bevelSegments: 3, curveSegments: 2
  });
  geo.computeBoundingBox();
  const bb = geo.boundingBox;
  geo.translate(-(bb.min.x + bb.max.x) / 2, -bb.min.y, -0.095);
  geo.computeVertexNormals();
  const H = bb.max.y - bb.min.y;

  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.1;
  renderer.outputColorSpace = THREE.SRGBColorSpace;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(26, 1, 0.1, 20);
  camera.position.set(0, H * 0.55, 3.4);
  camera.lookAt(0, H * 0.5, 0);

  scene.add(new THREE.HemisphereLight(0xffffff, 0xb8bccc, 1.1));
  const key = new THREE.DirectionalLight(0xffffff, 2.2);
  key.position.set(2.5, 4, 3.5);
  scene.add(key);
  const rim = new THREE.DirectionalLight(0xb4b8ff, 1.1);
  rim.position.set(-3, 2, -3);
  scene.add(rim);

  const hero = new THREE.Mesh(geo, new THREE.MeshPhysicalMaterial({
    color: COLOR, roughness: 0.4, metalness: 0, clearcoat: 0.8, clearcoatRoughness: 0.28
  }));
  scene.add(hero);

  function size(){
    const w = canvas.clientWidth, h = canvas.clientHeight, pr = renderer.getPixelRatio();
    if (!w || !h) return;
    if (canvas.width !== Math.floor(w * pr) || canvas.height !== Math.floor(h * pr)){
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    }
  }

  const ENTER = 1200;
  const easeOutBack = t => { const c = 1.6; return 1 + (c + 1) * Math.pow(t - 1, 3) + c * Math.pow(t - 1, 2); };
  let start = null, visible = true, raf = 0;

  function frame(now){
    if (start === null) start = now;
    size();
    const t = Math.min(1, (now - start) / ENTER);
    if (reduce){
      hero.scale.setScalar(1);
      hero.rotation.y = -0.25;
    } else if (t < 1){
      const e = easeOutBack(t);
      hero.scale.setScalar(Math.max(0.001, e));
      hero.rotation.y = (1 - t) * (1 - t) * -Math.PI * 2;
      hero.position.y = (1 - e) * -0.4;
    } else {
      const s = (now - start - ENTER) / 1000;
      hero.scale.setScalar(1);
      hero.position.y = 0;
      hero.rotation.y = Math.sin(s * 0.9) * 0.4;
      hero.rotation.z = Math.sin(s * 1.8) * 0.015;
    }
    renderer.render(scene, camera);
    if (reduce && t >= 1) return;
    if (visible) raf = requestAnimationFrame(frame);
  }

  document.addEventListener('visibilitychange', () => {
    visible = !document.hidden;
    cancelAnimationFrame(raf);
    if (visible) raf = requestAnimationFrame(frame);
  });
  raf = requestAnimationFrame(frame);
})();
